import { callNative } from '@/shared/utils/bridge';
import platform from '@/shared/utils/platform';
import store from '@/store';

// 根据 store 定位信息判断用户是否开启定位
export const isOpenLocationPermission = (): Promise<{
  isOpen: boolean;
}> => {
  if (platform.isHelloApp) {
    return callNative({
      classMap: 'SystemUtil',
      method: 'isOpenLocationPermission',
    });
  }
  /** 因微信小程序无定位权限，豁免检验，返回”已开启“状态 */
  if (platform.isWechatMini) {
    return Promise.resolve({ isOpen: true });
  }

  return Promise.resolve({ isOpen: !!store.state.base.cityInfo });
};
